import {
  PkRadio,
  PkRadioOption,
  PkAccordionItem,
  PkAccordionItemTitle,
  PkAccordionItemContent,
} from '@uefadigital/panenka-react';
import { memo, useCallback } from 'react';

import { useTranslateFn } from '@shared/Translate';
import { RoundPhase } from '@shared-types/match.types';

const FilterPhase = ({
  onFilterChange,
  filter,
  disableTournamentFilters,
}: {
  onFilterChange: any;
  filter: RoundPhase;
  disableTournamentFilters: boolean;
}) => {
  const t = useTranslateFn();

  const handleFilter = useCallback(
    (event: CustomEvent<{ selectedValue: string; checked: boolean }>) => {
      event.detail.checked && onFilterChange(event.detail.selectedValue);
    },
    [onFilterChange],
  );

  return (
    <PkAccordionItem expanded>
      <PkAccordionItemTitle>{t('phase')}</PkAccordionItemTitle>
      <PkAccordionItemContent>
        <PkRadio name='phase'>
          <PkRadioOption
            value='TOURNAMENT'
            onPkChange={handleFilter}
            isDisabled={disableTournamentFilters}
            checked={filter === RoundPhase.TOURNAMENT}
            uid='tournament'
          >
            {t('main_tournament')}
          </PkRadioOption>
          <PkRadioOption
            value='QUALIFYING'
            onPkChange={handleFilter}
            checked={filter === RoundPhase.QUALIFYING}
            uid='qualifying'
          >
            {t('qualifying')}
          </PkRadioOption>
        </PkRadio>
      </PkAccordionItemContent>
    </PkAccordionItem>
  );
};

export default memo(FilterPhase);
